/**
 * Represents whether a component has been instantiated and is ready to be rendered by react. I.e. all required work to render this component has been completed.
 */
export enum ComponentReadyToRenderState {
    NOT_READY,
    READY
}
